import { render, staticRenderFns } from "./feature-type-group.vue?vue&type=template&id=2d2ef4cc"
import script from "./feature-type-group.vue?vue&type=script&lang=js"
export * from "./feature-type-group.vue?vue&type=script&lang=js"
import style0 from "./feature-type-group.vue?vue&type=style&index=0&id=2d2ef4cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports